import transferenciaContaServices from '@/api/financialModule/transferenciaContaServices'

export default {
  insertTransferencia({ commit }, data) {
    return transferenciaContaServices.insertTransferencia(data)
  },
  updateTransferencia({ commit }, { id, data }) {
    return transferenciaContaServices.updateTransferencia(id, data)
  },

  deleteTransferencia({ commit }, id) {
    return transferenciaContaServices.deleteTransferencia(id)
  },
  filtroTransferencias({ commit }, { filter, pageConfig }) {
    return transferenciaContaServices
      .filtroTransferencias(pageConfig, filter)
      .then(result => {
        commit('SET_TRANSFERENCIAS', result.data.content)
        return result
      })
  },
  filtroTransferenciasSemMutation({ commit }, { filter, pageConfig }) {
    return transferenciaContaServices.filtroTransferencias(pageConfig, filter)
  },
  resetTransferencia({ commit }) {
    commit('RESET_TRANSFERENCIA')
  },
}
